import {BillingInfoDTO, PlanDTO} from '../../dtos/billing';
import {cloneDeep} from 'lodash';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {PlanActions, PlanState} from '../../models/plan';
import {Store} from '@ngxs/store';
import {Loader} from '../../models/loader/loader.redux';
import {firstValueFrom, Observable} from 'rxjs';
import {pl} from 'date-fns/locale';

@Component({
  selector: 'app-clinic-register-plan',
  templateUrl: './clinic-register-plan.component.html',
  styleUrls: ['./clinic-register-plan.component.scss'],
  animations: [fadeInAnimation]
})
export class ClinicRegisterPlanComponent implements OnInit {
  billingInfo$: Observable<BillingInfoDTO> = this.store.select<BillingInfoDTO>(PlanState.getBillingInfo);
  plans: PlanDTO[];
  timeSelected = false;
  planDtoSelected: PlanDTO;
  planSelectedIsHidden: boolean;
  @Input() planSelectedId: string;
  @Input() showTitle = true;
  @Input() widthFull = false;
  @Input() inBilling = false;
  @Input() alertMessage = '¡Todos los planes de suscripción tienen 30 días de prueba totalmente gratis! Además puedes cancelar el plan en cualquier momento, incluso antes de que termine el periodo de prueba. Es importante saber que no se realizará nigún cobro hasta pasado el periodo de prueba.';
  @Output() selectPlan: EventEmitter<PlanDTO> = new EventEmitter<PlanDTO>();
  constructor(
    private store: Store
  ) { }

  /**
   * Inicializa las propiedades
   */
  async ngOnInit(): Promise<void> {
    this.initValuesHttp().then();
  }

  /**
   * Obtiene los planes disponibles.
   */
  async initValuesHttp(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true, 'Cargando los planes...'))));
    await firstValueFrom((this.store.dispatch(new PlanActions.Get())));
    this.plans = cloneDeep(await firstValueFrom((this.store.selectOnce(PlanState.getPlans))));
    if (!this.plans) {
      await firstValueFrom((this.store.dispatch(new Loader(false))));
      return;
    }
    if (!this.planSelectedId) {
      // const plan: PlanDTO = this.plans.find((item: PlanDTO) => item.product.name === 'Plan Delie Individual' && item.interval === 'month');
      const plan: PlanDTO = this.plans.find((item: PlanDTO) => item.interval === 'month');
      this.selectPlanId(plan._id);
      this.onSelectedPlan(plan);
    } else {
      let plan: PlanDTO = this.plans.find((item: PlanDTO): boolean => item._id === this.planSelectedId);
      if (!plan) {
        this.planSelectedIsHidden = true;
        const billingInfo: BillingInfoDTO = await firstValueFrom(this.billingInfo$);
        plan = billingInfo.plan;
      }
      this.selectPlanId(plan._id);
      this.onSelectedPlan(plan);
      this.onChangeTimePlanSelected(plan.interval === 'year', true);
    }
    await firstValueFrom((this.store.dispatch(new Loader(false))));
  }

  /**
   * Se selecciona un plan
   * @param id id
   */
  selectPlanId(id: string): void {
    this.planSelectedId = id;
  }

  /**
   * Envia los valores del componente.
   */
  getValue(): { planSelectedId: string, timeSelected: boolean } {
    return {
      planSelectedId: this.planSelectedId,
      timeSelected: this.timeSelected
    };
  }

  /**
   * Cambia el periodo de tiempo de los planes.
   * @param time tiempo a cambiar
   * @param hasPlan si tiene plan
   */
  onChangeTimePlanSelected(time: boolean, hasPlan?: boolean): void {
    this.timeSelected = time;
    if (hasPlan) return;
    const plan: PlanDTO = this.plans.find((item: PlanDTO) => item.product.name === this.planDtoSelected.product.name && item.interval === (time ? 'year' : 'month'));
    this.selectPlanId(plan._id);
    this.onSelectedPlan(plan);
  }

  /**
   * Selecciona un plan
   * @param plan plan DTO
   */
  onSelectedPlan(plan: PlanDTO): void {
    this.planDtoSelected = plan;
    this.selectPlan.emit(plan);
  }
}
